import { GA_EVENTS as SHARED_GA_EVENTS, GA_CATEGORIES as SHARED_GA_CATEGORIES } from "./shared";

export { GA_LABELS, ITEM_SOURCES, type GaEvent } from "./shared";

/**
 * WEB variant of the GA constants. See `./shared.ts` for what is shared and why these are
 * `as const` objects rather than enums.
 *
 * ⚠️ **`GA_EVENTS` and `GA_CATEGORIES` are RE-DECLARED here rather than re-exported**, because
 * this platform has strictly more of each. `export * from "./shared"` would then collide with
 * the wider definitions; spreading the shared ones in keeps a single source for the common keys
 * while letting this file add its own.
 */

/** The shared events plus this platform's app-update lifecycle, which the other has no shell for. */
export const GA_EVENTS = {
  ...SHARED_GA_EVENTS,
  // app update lifecycle
  UPDATE_POPUP_SHOWN: "update_popup_shown",
  UPDATE_CTA_CLICK: "update_cta_click",
  UPDATE_POPUP_DISMISS: "update_popup_dismiss",
  UPDATE_MANUAL_DOWNLOAD_CLICK: "update_manual_download_click",
  UPDATE_DOWNLOAD_SUCCESS: "update_download_success",
  UPDATE_DOWNLOAD_ERROR: "update_download_error",
  UPDATE_DONE_CLICK: "update_done_click",
  UPDATE_LATER_CLICK: "update_later_click",
  UPDATE_FULL_STARTED: "update_full_started",
} as const;

/** ⚠️ `TESTING` exists only on this platform. Do not move it to `shared.ts`. */
export const GA_CATEGORIES = {
  ...SHARED_GA_CATEGORIES,
  TESTING: "Testing",
} as const;
